<template>
    <a href="javascript:;" @click.prevent="showDeAttachCaptainPopUp(itemID)" class="btn btn-danger btn-sm">
        <span class="d-none d-lg-inline mr-2">
          {{ $t(`labels.de_attach_captain`) }}
        </span>
        <span>
          <i class="fas fa-unlink"></i>
        </span>
    </a>
</template>

<script>
    import { SUPPLIERS_DE_ATTACH_CAPTAIN as CRUD_ACTION_DE_ATTACH_CAPTAIN } from "actions/suppliers";
    export default {
        name: "SupplierActionsDeAttachCaptain",
        props: {
            itemID:{}
        },
        data(){
            return {}
        },
        methods:{
            showDeAttachCaptainPopUp(id) {
                swal({
                    title: this.$i18n.t("labels.de_attach_captain"),
                    text: this.$i18n.t("labels.de_attach_captain_item"),
                    type: "input",
                    showCancelButton: true,
                    closeOnConfirm: false,
                    content: "input",
                    buttons: [
                        this.$i18n.t("labels.cancel"),
                        this.$i18n.t("labels.de_attach_captain"),
                    ],
                    inputPlaceholder: "Write something",
                }).then((value) => {
                    const captainId = parseInt(value, 0);
                    if (value !== null && Object.keys(value).length !== 0 && captainId) {
                        this.deAttachCaptainToSupplier(id, captainId);
                    }
                });
            },
            deAttachCaptainToSupplier(id, captain_id) {
                this.$store.dispatch(CRUD_ACTION_DE_ATTACH_CAPTAIN, {
                    id,
                    captain_id
                })
                .then(() => {
                    this.$emit('input',false);
                    swal({
                        icon: "success",
                        text: this.$i18n.t("messages.de_attach_captain_success"),
                        buttons: false,
                        timer: 5000,
                    });
                })
                .catch((error) => {
                    let message = "";
                    if (error.response) {
                        let responseData = error.response.data;

                        if (responseData.errors && responseData.errors.error) {
                            message = responseData.errors.error;
                        } else {
                            message = this.$i18n.t("messages.de_attach_captain_error");
                        }
                    }
                    if(message){
                        swal({
                            icon: "error",
                            text: message,
                            buttons: false,
                            timer: 5000,
                        });
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
